import { registerTheme } from '../../theme';
import { DEFAULT_BAR_THEME } from '../bar/theme';

registerTheme('groupedBar', DEFAULT_BAR_THEME);
